import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetBankAccountTransactionListPagingAndFilterRequest } from '../../../../models/request/bankAccountTransaction/GetBankAccountTransactionListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetBankAccountTransactionListPagingAndFilterRequest
    getData: (_filter?: GetBankAccountTransactionListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetBankAccountTransactionListPagingAndFilterRequest>>
    selectedCount: number
    onSearchSubmit: (e: any) => void
}

const BankAccountTransactionListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    onSearchSubmit,
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                searchOnly
                hideSearch
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
                allowSelected={false}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Firma, İlgili Hesap kolonunun altındaki
                metin filtresinde (firma, banka hesabı ya da kasa adı). Arama kutusundaki
                Transaction Id ve Açıklama kendi kolonlarının filtresinde. */}

            {/* <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/bankAccountTransaction/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Kasa Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment> */}
        </React.Fragment >
    )
}

export default BankAccountTransactionListFilters;